import { useEffect } from "react";
import MainContainer from "../../components/container/MainContainer";
import LocationHeader from "../../components/header/LocationHeader";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import Table from "../../components/tables/Table";

import Loading from "../../components/loading/Loading";
import { useAuthorization } from "../../hooks/useAuthorization";
import AddDepartment from "./AddDepartment";
import {
  getDepartments,
  unsetDepartments,
} from "../../features/departmentSlice";
import { useLocation } from "react-router-dom";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const Department = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const departments = useSelector((state) => state.departments.data);
  const loading = useSelector((state) => state.departments.load.getDepartments);
  const { isAuthorized } = useAuthorization();

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Department" },
    { id: "slug", text: "Slug" },
  ];

  const openAddDepartmentModal = () => {
    dispatch(openModal(<AddDepartment />));
  };

  useEffect(() => {
    dispatch(getDepartments());
    return () => {
      dispatch(unsetDepartments());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <Modal>{modalContent}</Modal>
      <MainContainer>
        <LocationHeader
          title="Departments"
          action={openAddDepartmentModal}
          links={[]}
          authorized={isAuthorized("departments", "create")}
        />
        <main className="table-container">
          <Table columns={columns} data={departments} link />
        </main>
      </MainContainer>
    </>
  );
};

export default Department;
